import { Navigate } from "react-router-dom";
import { useAtomValue } from "jotai";
import { userTypeAtom } from "../atoms/authAtoms";
import { postAuthDestination } from "../utils/reviewerNav";

/**
 * Role-aware destination for an authenticated visit to `/`.
 *
 * Keeping the root route behind PrivateRoute means an unauthenticated visit is
 * preserved as `/` through sign-in instead of first becoming `/worklist` and
 * being mistaken for a user-requested deep link. Once authenticated, the same
 * role-based routing used by every sign-in path chooses the landing page.
 */
const AuthenticatedHome = () => {
  const userType = useAtomValue(userTypeAtom);
  return <Navigate to={postAuthDestination({ userType })} replace />;
};

export default AuthenticatedHome;
